export const setPayment = (value, page, limit, count) => {
  return {
    type: "SET_PAYMENT",
    payload: { data: value, page, limit, count },
  };
};
